import { render, staticRenderFns } from "./header.vue?vue&type=template&id=878bedc8&scoped=true&lang=pug&"
import script from "./header.vue?vue&type=script&lang=ts&"
export * from "./header.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "878bedc8",
  null
  
)

export default component.exports